import * as React from "react";
import { Stack } from "@fluentui/react";
import { GroupItem, Menu, MenuType } from "../Menu/Menu";

export interface DetailView {
  /**
   * Id attribute associated to DetailView
   */
  id: string;
  /**
   * Content or an array of content to be displayed
   */
  content: React.ReactChild | React.ReactChild[];
}

export interface DetailViewsProps {
  /**
   * Array of DetailViews
   */
  views: DetailView[];
  /**
   * List of menu GroupItems
   */
  menu: GroupItem[];
  /**
   * Menu is fixed and cannot be collapsed
   * @default false
   */
  menuFixed?: boolean;
  /**
   * Active view id. If no value is passed, uses first view id
   */
  activeViewId?: string;
  /**
   * Callback for menu item selection
   */
  onMenuItemSelect?: (id: string) => void;
}

/**
 * The DetailsView component handles rendering left menu and content view
 */
export const DetailViews = ({
  views,
  activeViewId,
  onMenuItemSelect,
  menu,
  menuFixed = false,
}: DetailViewsProps): JSX.Element => {
  const selectedItem = views.find(item => item.id === (activeViewId || views?.[0]?.id));
  const selectedContent = selectedItem?.content;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const internalOnMenuItemSelect = (item: any): void => {
    onMenuItemSelect?.(item.key);
  };

  const groups = menu.map(groupItem => ({
    heading: groupItem.heading,
    items: groupItem.items.map(menuItem => ({
      ...menuItem,
      onClick: internalOnMenuItemSelect,
    })),
  }));

  return (
    <Stack horizontal tokens={{ childrenGap: 25 }} style={{ height: "100%" }}>
      <Stack.Item>
        <Menu
          isCollapsible={!menuFixed}
          type={MenuType.SIDE_MENU}
          groups={groups}
          selectedKey={selectedItem?.id}
        />
      </Stack.Item>
      <Stack.Item style={{ flex: 1, paddingRight: 25, height: "100%" }}>
        {selectedContent}
      </Stack.Item>
    </Stack>
  );
};
